import React, { useState } from 'react';
import { authAPI } from '../services/api';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    setError('');

    try {
      const response = await authAPI.recovery({ email });
      setMessage(response.data.message || 'If the email address exists, a password reset link has been sent.');
    } catch (err) {
      setError('An error occurred. Please try again.');
      console.error('Password reset error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="password-reset-container" style={{ maxWidth: '520px', margin: '40px auto', textAlign: 'center' }}>
      <div className="password-reset-logo" style={{ marginBottom: '16px' }}>
        <img src="/assets/forgot-password.png" alt="Password Reset" className="logo-image" />
      </div>
      <h1 className="password-reset-title">Reset Password</h1>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          marginBottom: '16px', 
          backgroundColor: '#d4edda', 
          color: '#155724', 
          borderRadius: '4px',
          border: '1px solid #c3e6cb'
        }}>
          {message}
        </div>
      )}
      
      {error && (
        <div style={{ 
          padding: '12px', 
          marginBottom: '16px', 
          backgroundColor: '#f8d7da', 
          color: '#721c24', 
          borderRadius: '4px',
          border: '1px solid #f5c6cb'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ marginBottom: '16px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', textAlign: 'left' }}>
            Email Address
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter your email address"
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
            opacity: isSubmitting ? 0.7 : 1
          }}
        >
          {isSubmitting ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>

      <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
        Enter your email address and we'll send you a link to reset your password.
      </p>

      <div style={{ marginTop: '16px' }}>
        <a href="/login" style={{ color: '#007bff', textDecoration: 'none' }}>
          Back to Login
        </a>
      </div>
    </div>
  );
};

export default PasswordReset; 